import axios from 'axios';

import ls, { ACCESS_TOKEN_KEY } from '../localstorage';

import { BASE_URL_V3 } from '@/constants/urls';
import Config from '@/config';

const axiosClient = axios.create({
  baseURL: BASE_URL_V3,
});

// const axiosRubyClient = axios.create({
//   baseURL: 'https://api.v2.gravywork.com',
// });

const axiosRubyClient = axios.create({
  baseURL: Config.BASE_RUBY_URL || 'https://api.v2.gravywork.com',
});

axiosClient.interceptors.request.use(async (config) => {
  const token = ls.get(ACCESS_TOKEN_KEY);

  if (token && config.headers) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

axiosRubyClient.interceptors.request.use(async (config) => {
  const token = ls.get(ACCESS_TOKEN_KEY);

  if (token && config.headers) {
    config.headers.Authorization = `bearer ${token}`;
  }

  // Ensure Content-Type is set for PATCH/POST/PUT requests
  if (
    config.method &&
    ['patch', 'post', 'put'].includes(config.method.toLowerCase())
  ) {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      // logic for refresh token
      // const access_token = await refreshAccessToken();
      // originalRequest.headers.Authorization = 'bearer ' + newToken;
      // return axiosClient(originalRequest);
    } else if (error?.response?.status === 401) {
      // Logout logic
    }
    return Promise.reject(error);
  },
);

axiosRubyClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      // logic for refresh token
      // const access_token = await refreshAccessToken();
      // originalRequest.headers.Authorization = 'bearer ' + newToken;
      // return axiosRubyClient(originalRequest);
    } else if (error?.response?.status === 401) {
      // Logout logic
    }
    return Promise.reject(error);
  },
);

export { axiosRubyClient };
export default axiosClient;
